import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import DataTable from "@/components/layout/DataTable.vue";
import {computed, ref, watch} from "vue";
import {useI18n} from "vue3-i18n";
import {Guid} from "@/types";
import {notifyError, notifySuccess} from "@/notify";
import {useActivityOccurrenceService} from "@/inversify.config";
import {ActivityRegistration} from "@/types/entities/activity";
import {SucceededOrNotResponse} from "@/types/responses";


export default /*#__PURE__*/_defineComponent({
  __name: 'ActivityRegistrationTable',
  props: {
    activityOccurrenceId: {},
    registrations: {},
    registrationsAreLoading: { type: Boolean },
    registrationsSearchValue: {}
  },
  emits: ["registrationDeleted"],
  setup(__props: any, { emit: __emit }) {

const {t} = useI18n();

const activityOccurrenceService = useActivityOccurrenceService();

// eslint-disable-next-line no-undef
const props = __props

// eslint-disable-next-line
const emit = __emit;

const activityOccurrenceId = ref(props.activityOccurrenceId);
const registrations = ref(props.registrations);
const registrationsAreLoading = ref(props.registrationsAreLoading);
const registrationsSearchValue = ref(props.registrationsSearchValue);

watch(props, (newProps) => {
  registrations.value = newProps.registrations;
  activityOccurrenceId.value = newProps.activityOccurrenceId;
  registrationsAreLoading.value = newProps.registrationsAreLoading;
  registrationsSearchValue.value = newProps.registrationsSearchValue;
});

const registrationsItems = computed(() => {
  let items: any[] = []
  if (registrations.value.length === 0)
    return []
  registrations.value.forEach((registration: ActivityRegistration) => {
    items.push({
      id: registration.id,
      firstName: registration.billingAddress?.firstName,
      lastName: registration.billingAddress?.lastName,
      email: registration.billingAddress?.email,
      participantsCount: registration.participants?.length,
      isPaid: registration.isFree ? t("global.free") : registration.isPaid ? t("global.yes") : t("global.no"),
      actions: {
        edit: true,
        delete: true,
      }
    })
  })
  return items
});

function handleEdit(id: string) {
  const appUrl = new URL(window.location.href);
  let url = new URL(`${appUrl.origin}/activites-et-formations/inscription`);
  const params = new URLSearchParams({activityOccurrenceId: activityOccurrenceId.value, activityRegistrationId: id});
  url.search = params.toString();
  window.location.href = url.toString();
}

async function handleDelete(activityRegistration: any) {
  if (activityRegistration?.id == null || !Guid.isValid(activityRegistration.id ?? ""))
    return;

  let confirmDelete = confirm(t("registrations.form.deleteConfirmation"));
  if (!confirmDelete) return;

  let result: SucceededOrNotResponse = await activityOccurrenceService.deleteActivityRegistration(activityRegistration.id);

  if (result?.succeeded) {
    notifySuccess(t("registrations.form.deleteSuccess"));
    emit("registrationDeleted");
  } else {
    notifyError(t("registrations.form.deleteError"));
  }
}

const registrationsHeaders = [
  {
    text: t("participants.lastName"),
    value: "lastName",
    sortable: true,
  },
  {
    text: t("participants.firstName"),
    value: "firstName",
    sortable: true,
  },
  {
    text: t("participants.email"),
    value: "email",
    sortable: true,
  },
  {
    text: t("participants.participants"),
    value: "participantsCount",
    sortable: true,
  },
  {
    text: t("invoice.isPaid"),
    value: "isPaid",
    sortable: true,
  },
  {
    text: t("global.table.actions"),
    value: "actions",
  }
]

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(DataTable, {
    headers: registrationsHeaders,
    "is-loading": registrationsAreLoading.value,
    items: registrationsItems.value,
    "search-value": registrationsSearchValue.value,
    onDelete: handleDelete,
    onEdit: handleEdit
  }, null, 8, ["is-loading", "items", "search-value"]))
}
}

})